export const getResponsiveImage = (
    image: string,
    size = 'mobile',
    format: any = null,
) => {
    const imageHref = 'img2.storyblok.com/';
    const imageEnd = image.replace('a.storyblok.com/', '');
    let newFormat = '';
    let newSize = '768x0/';

    if (size === 'tablet') {
        newSize = '992x0/';
    } else if (size === 'desktop') {
        newSize = '1440x0/';
    } else if (size === 'big-desktop') {
        newSize = '1920x0/';
    }

    if (format) {
        newFormat = `filters:format(${format})`;
    }

    const options = newSize + newFormat;

    return `//${imageHref}${options}${imageEnd}`;
};
